import React from "react";

const ExerciseCard = ({ exercise, onClick }) => {
  return (
    <div
      onClick={() => onClick(exercise)}
      className="bg-white border border-slate-300 rounded-lg"
    >
      <img
        className="mb-2 h-36 w-full object-cover rounded-t-lg"
        src={exercise?.image ?? ""}
        alt={exercise?.title ?? ""}
      />
      <div className="h-20 md:h-16 px-3 py-0.5">
        <h4 className="font-medium text-black text-base text-ellipsis overflow-hidden">
          {exercise?.title ?? ""}
        </h4>
      </div>
    </div>
  );
};

export default ExerciseCard;
